// extracted by mini-css-extract-plugin
export var quillEditor = "_k1-1";
export var variable = "_k1-0";